var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 993.7 1011.6",
    style: {
      enableBackground: "new 0 0 993.7 1011.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000049921587336935676610000007928156772005912201_);}\r\n\t.st1{fill:url(#SVGID_00000088834483017619757040000015769900408616711824_);}\r\n\t.st2{fill:url(#SVGID_00000021104782693029829690000011230331122162893751_);}\r\n\t.st3{fill:url(#SVGID_00000132060281559963154290000016938832343385994677_);}\r\n\t.st4{fill:url(#SVGID_00000166665446289471619820000012266520182983194258_);}\r\n\t.st5{fill:#3086FF;}\r\n\t.st6{fill:url(#SVGID_00000087373806913456469860000008800928407905696648_);}\r\n\t.st7{fill:url(#SVGID_00000090269614757890996630000009916872393986296199_);}\r\n\t.st8{fill:url(#SVGID_00000016038410007150727440000011638274034412595635_);}\r\n\t.st9{opacity:0.5;fill:url(#SVGID_00000160893676362637674090000004172843816412763820_);enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M977,411.5H507.3v192.2h269.9c-4.3,27.2-14.1,54-28.3,78.4c-16.4,28-36.5,49.3-57.3,65.5 c-62,48.6-134.4,58.5-184.6,58.5c-126.9,0-235.3-83.8-277.3-197.6c-1.7-4.1-2.8-8.4-4.2-12.6c-9.3-29-14.3-59.7-14.3-91.5 s5.5-65,15.5-95C266.1,291,377,202.6,507.1,202.6c26.2,0,51.4,3.2,75.3,9.5c54.6,14.5,93.3,43,116.9,65.6l142.8-142.9 C755.1,53.6,641.9,4.3,506.8,4.3c-108,0-207.7,34.4-289.4,92.4C151.1,143.8,96.8,206.9,60.1,280.1C26,348,7.3,423.3,7.3,504.2 s18.7,157,52.8,224.3v0.4c36,71.4,88.7,132.9,152.8,179.8c55.9,41,156.3,95.5,293.9,95.5c79.2,0,149.3-14.6,211.2-41.9 c44.6-19.7,84.2-45.4,120-78.4c47.3-43.6,84.3-97.6,109.6-159.7s38.8-132.4,38.8-208.5C986.4,480.3,982.9,444.2,977,411.5 L977,411.5L977,411.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123433754465042791900000007006388130890868625_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000123433754465042791900000007006388130890868625_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000061430181746211133040000009383317111597718407_",
    cx: -750.1392,
    cy: 851.528,
    r: 260.9172,
    gradientTransform: "matrix(-7.798395e-02 -1.9084 2.8077 -0.1147 -2078.2585 -481.4066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#1ABD4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#6EC30D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#8AC502"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#A2C600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#C8C903"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#EBCB03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F7CD07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FDCD04"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#FDCE05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#FFCE0A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061430181746211133040000009383317111597718407_)"
    },
    d: "M0.1,507.6 c0.5,79.6,22.7,161.8,56.4,228.2v0.5c24.3,48.2,57.5,86.2,95.3,123.9L380.3,775c-43.2-22.4-49.8-36.2-80.8-61.2 c-31.7-32.6-55.3-70.1-70-114H229l0.6-0.5c-9.7-29-10.6-59.8-11-91.8L0.1,507.6L0.1,507.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026869343196489264610000007251638992321659034_",
    cx: 429.0726,
    cy: 839.8392,
    r: 174.7116,
    gradientTransform: "matrix(1.98 0 0 2.55 -16.9018 -1865.2352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#FB4E5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4540"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026869343196489264610000007251638992321659034_)"
    },
    d: "M507.3,0.6c-22.6,81-13.9,159.8,0,205.6 c26.1,0,51.2,3.2,75,9.5c54.6,14.5,93.2,43,116.9,65.6l146.5-146.5C758.9,53.7,654.5,0.8,507.3,0.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130644913407809499280000001534952346210320291_",
    cx: -524.7332,
    cy: 871.2011,
    r: 260.9172,
    gradientTransform: "matrix(-1.8546 1.0271 1.3954 2.5194 -1548.0699 -1721.6493)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#FF4541"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FF4540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#FF4640"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#FF473F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FF5138"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#FF5B33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#FF6C29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8C18"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130644913407809499280000001534952346210320291_)"
    },
    d: "M506.8,0C396,0,293.7,35.2,209.9,94.8 c-31.1,22.1-59.7,47.7-85.1,76.1c-6.6,63.8,49.9,142.3,161.8,141.6c54.3-64.5,134.6-106.3,224-106.3c0.1,0,0.1,0,0.3,0L507.3,0 C507.3,0,506.9,0,506.8,0z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000136372514404818353960000003297112461699310236_",
    cx: -556.2387,
    cy: 804.07,
    r: 260.9172,
    gradientTransform: "matrix(-3.3626 -4.3902 -1.6195 1.2405 -60.7317 -2494.9011)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#0CBA65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#0BB86D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#09B479"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#08AD93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#0AA6A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#0D9CC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#1893DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#258BF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#3086FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136372514404818353960000003297112461699310236_)"
    },
    d: "M872.4,530.7l-98.9,69.4 c-4.3,27.2-14.1,54-28.4,78.4c-16.4,28-36.5,49.3-57.3,65.5c-61.9,48.5-134.1,58.4-184.3,58.5c-51.9,90.3-61,135.5,3.7,208.4 c80-0.1,150.9-14.8,213.5-42.4c45.2-20,85.3-46,121.6-79.5c47.9-44.2,85.5-98.9,111.1-161.9c25.6-62.9,39.3-134.1,39.3-211.3 L872.4,530.7L872.4,530.7z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M500,404.2v206.8h475.7c4.2-28.3,18-65,18-95.3c0-35.5-3.5-78.8-9.4-111.5H500L500,404.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085242695695660628200000009297550696100668595_",
    cx: -9.027,
    cy: 932.9841,
    r: 260.9172,
    gradientTransform: "matrix(-0.2386 2.0562 2.8409 0.3297 -2191.0896 -197.5597)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#FF4E3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#FF8A1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#FFA312"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFB60C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#FFCD0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#FECF0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#FECF08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDCD01"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085242695695660628200000009297550696100668595_)"
    },
    d: "M127.1,163.6 c-29.4,32.8-54.4,69.5-74.3,109.2C18.7,340.7,0,423.3,0,504.2c0,1.1,0.1,2.3,0.1,3.4c15.1,29.6,208.7,23.9,218.5,0 c0-1.1-0.1-2.2-0.1-3.3c0-33.2,5.5-57.7,15.5-87.7c12.3-37,31.7-71.1,56.4-100.4c5.6-7.3,20.6-23,24.9-32.4c1.6-3.6-3-5.6-3.3-6.9 c-0.3-1.4-6.6-0.3-8-1.3c-4.5-3.4-13.3-5.1-18.7-6.6c-11.5-3.3-30.5-10.6-41-18.2C210.9,226.8,158.9,198.2,127.1,163.6 L127.1,163.6L127.1,163.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000124877988382990170140000000768579625827035016_",
    cx: -212.4781,
    cy: 447.3646,
    r: 150.0657,
    gradientTransform: "matrix(-1.1938 1.3203 -3.731 -3.3735 1784.7537 1878.5856)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#FF4C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FF692C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#FF7825"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#FF8D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9F13"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124877988382990170140000000768579625827035016_)"
    },
    d: "M245,277c77.3,47.9,99.6-24.1,151-46.7 L306.6,40.9c-32.9,14.1-64,31.7-92.9,52.2c-43.1,30.6-81.1,68-112.5,110.5L245,277z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165204502318271102470000001480577122862854584_",
    cx: -867.2059,
    cy: 415.3732,
    r: 260.9172,
    gradientTransform: "matrix(-1.8546 -1.0271 1.3954 -2.5194 -1548.0699 1230.828)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#0FBC5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#0FBC5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#0FBC5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#0FBC5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#12BC58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#28BF3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#38C02B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#52C218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#67C30F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#86C504"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165204502318271102470000001480577122862854584_)"
    },
    d: "M276.5,760.4 c-103.8,38.3-120.1,39.7-129.6,105.4c18.3,18.2,37.9,35.1,58.7,50.3c55.9,41,163.6,95.5,301.2,95.5c0.1,0,0.3,0,0.5,0V798.8 c0,0-0.2,0-0.3,0c-51.6,0-92.7-13.8-134.9-37.9c-10.4-5.9-29.3,10-38.9,2.9C319.8,754,288,772.3,276.5,760.4L276.5,760.4 L276.5,760.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087379952258074224670000000537683168415166865_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.2093,
    y1: 1872.6742,
    x2: 704.1627,
    y2: 1872.6742,
    gradientTransform: "matrix(0.96 0 0 0.99 -105.8252 -952.1473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0FBC5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0CBA65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000087379952258074224670000000537683168415166865_)",
      enableBackground: "new"
    },
    d: " M446.5,792.1v215.8c19.2,2.3,39.3,3.7,60.3,3.7s41.5-1.1,61.3-3.1V793.5c-22.2,3.9-43.1,5.3-61.1,5.3 C486.2,798.7,466,796.3,446.5,792.1L446.5,792.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo_google.d13cd74ef2ef66b125ee2175b006c10c.svg";
export { ForwardRef as ReactComponent };